import { useTranslation } from "react-i18next";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import { TechAreaService } from "../../../services/TechAreaService";

export default function TechAreaDelete({ techArea, onClose, isOpen }) {
  let { t } = useTranslation();
  function deleteTechArea() {
    TechAreaService.delete(techArea.id).then((data) => {
      onClose();
    });
  }

  return (
    <ModalContainer
      modalTitle={t("Delete  Tech Area")}
      onClose={onClose}
      submitButtonAction={deleteTechArea}
      submitButtonTitle={t("Delete")}
      cancelButtonTitle={t("Cancel")}
      cancelButtonAction={onClose}
      submitButtonType="button"
      isOpen={isOpen}
    >
      <div className="form-group text-center">
        <label className="label"> {techArea?.description}</label>
        <br />
        <label className="label">
          {t("Are you sure you want to delete ?")}
        </label>
      </div>
    </ModalContainer>
  );
}
